import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.27 8s-1.946 3.892-6.487 3.892C3.243 11.892 1.297 8 1.297 8s1.946-3.892 6.486-3.892S14.27 8 14.27 8Z",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.784",
      cy: "8",
      r: "1.946",
      stroke: "currentColor",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }